module.exports = __webpack_public_path__ + "img/tablet.721571.png";